import type { FC, ReactNode } from 'react';
import React from 'react';
import styled from 'styled-components';

export interface CardListProps {
  readonly children?: ReactNode;
}

export const CardList: FC<CardListProps> = ({ children }) => (
  <CardListWrapper>
    {React.Children.map(children, (child) => (
      <div>{child}</div>
    ))}
  </CardListWrapper>
);

const CardListWrapper = styled.div`
  gap: var(--spacing-relative-md);
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(286px, 1fr));
  justify-content: flex-start;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    &:has(> :nth-child(1):last-child) {
      grid-template-columns: min(380px, 100%);
    }

    &:has(> :nth-child(2):last-child) {
      grid-template-columns: repeat(2, minmax(286px, 380px));
    }
  }
`;
